import { useTranslation } from "react-i18next";

import { SERIES_KINDS } from "@/components_v2/Charts/Series/constants";
import SeriesCard from "@/features/certifications/analytics/components/SeriesCard";
import {
  CARD_SIZES,
  CHART_HEIGHT,
  INTERVALS,
  SERIES_COLORS,
} from "@/features/certifications/analytics/constants";
import { getBucketLabels } from "@/features/certifications/analytics/utils";
import { TimelineCardProps } from "@/features/certifications/analytics/types";

const TimelineCards = ({ data, isLoading, isError }: TimelineCardProps) => {
  const { t } = useTranslation();
  const prefix = "certification.admin.analytics.timeline";
  const points = data?.points ?? [];
  const labels = data ? getBucketLabels(points, data.interval) : [];
  const categoryLabel = t(
    `certification.admin.analytics.period.category.${data?.interval ?? INTERVALS.WEEK}`,
  );
  const shared = {
    labels,
    categoryLabel,
    isLoading,
    isError,
    size: CARD_SIZES.HALF,
  };

  return (
    <>
      <SeriesCard
        {...shared}
        title={t(`${prefix}.activeLearners.title`)}
        info={t(`${prefix}.activeLearners.info`)}
        height={CHART_HEIGHT}
        series={[
          {
            key: "activeLearners",
            label: t(`${prefix}.activeLearners.series`),
            data: points.map((point) => point.activeLearners),
            color: SERIES_COLORS[0],
            kind: SERIES_KINDS.AREA,
          },
        ]}
      />

      <SeriesCard
        {...shared}
        title={t(`${prefix}.flow.title`)}
        height={CHART_HEIGHT}
        series={[
          {
            key: "enrollments",
            label: t(`${prefix}.flow.enrollments`),
            data: points.map((point) => point.enrollments),
            color: SERIES_COLORS[0],
          },
          {
            key: "withdrawals",
            label: t(`${prefix}.flow.withdrawals`),
            data: points.map((point) => point.withdrawals),
            color: SERIES_COLORS[1],
          },
          {
            key: "certificatesIssued",
            label: t(`${prefix}.flow.certificatesIssued`),
            data: points.map((point) => point.certificatesIssued),
            color: SERIES_COLORS[2],
            kind: SERIES_KINDS.LINE,
          },
        ]}
      />

      <SeriesCard
        {...shared}
        title={t(`${prefix}.work.title`)}
        height={CHART_HEIGHT}
        series={[
          {
            key: "knowledgeCheckSubmissions",
            label: t(`${prefix}.work.knowledgeCheckSubmissions`),
            data: points.map((point) => point.knowledgeCheckSubmissions),
            color: SERIES_COLORS[0],
            kind: SERIES_KINDS.LINE,
          },
          {
            key: "contributions",
            label: t(`${prefix}.work.contributions`),
            data: points.map((point) => point.contributions),
            color: SERIES_COLORS[1],
            kind: SERIES_KINDS.LINE,
          },
        ]}
      />
    </>
  );
};

export default TimelineCards;
